import { createSelector } from '@ngrx/store'
import { getAnswersState } from './state.selector'

export const selectAnswers = createSelector(
  getAnswersState,
  answers => answers
)
